import { IHierarchyItem, IItemProperty } from "../../backend/interfaces/IItem";
import { PropertyDataType } from "../../backend/constants/datatypes";

export const mapDataById = (data: Array<IHierarchyItem>): { [id: number]: IHierarchyItem } => {
  return Object.fromEntries(data.map((item) => [item.id, item])) as { [id: number]: IHierarchyItem };
};

export const getIdsFromLookupProperties = (properties: IItemProperty[]): number[] => {
  const ids = [];
  for (const property of properties) {
    if (property.dataType === PropertyDataType.Lookup && property.value) {
      ids.push(parseInt(property.value));
    } else if (property.dataType === PropertyDataType.MultiSelectLookup && property.value) {
      ids.push(property.value.split(",").map((s) => parseInt(s)));
    }
  }
  return ids;
};
